module.exports = __webpack_public_path__ + "static/VikasChopra-3240768de31bd230ff6dd14b06371036.jpg";